/* eslint-disable @typescript-eslint/prefer-optional-chain */
import React from 'react';

export function PositionHandler(props) {
  const { positionStyle, children, instance, useLandscapeCommonStyle, useLandscapeFixedWrapperStyle } = props;
  // TODO 由于 cli 声称模版未默认支持可选链，后端打包暂不支持可选链，后续升级 cli
  const fixedWidth = useLandscapeFixedWrapperStyle
    ? (instance && instance.landscapeFixedWrapperStyle && instance.landscapeFixedWrapperStyle.width)
    : (instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.width);

  const fixedHeight = useLandscapeFixedWrapperStyle
    ? (instance && instance.landscapeFixedWrapperStyle && instance.landscapeFixedWrapperStyle.height)
    : (instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.height);

  const commonStyle = useLandscapeCommonStyle
    ? (instance && instance.landscapeCommonStyle)
    : (instance && instance.commonStyle);

  const commonWidth = commonStyle && commonStyle.width;

  const styleOBj = {
    ...positionStyle,
    width: fixedWidth || (commonWidth ? 'auto' : '100%'),
    height: fixedHeight || 'auto',
    zIndex: (commonStyle && commonStyle.zIndex) || 10,
  };

  return <div style={styleOBj}>
    {children}
  </div>;
}
